import { Component, OnInit } from '@angular/core';
import { ActivatedRoute}  from '@angular/router';
import {FormControl, FormGroup} from "@angular/forms";
import { IdiomasServiceN35 } from 'app/main/wizard-n35/services/idiomas.service';
import *  as $ from 'jquery';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {
  dataId:any;
  data = [
    {
      id: "115",
      tittle : "Lista verificación: 5.1",
      info: "Los aspectos a verificar durante la evaluación de la conformidad de la presente Norma se realizarán, según aplique, mediante de la revisión documental de conformidad con lo siguiente:",
      steps: [
        {
          descripcion: "La promoción de un entorno organizacional favorable;",
          status: "CUMPLE",
        },{
          descripcion: "La prevención de los factores de riesgo psicosocial, y",
          status: "CUMPLE"
        },{
          descripcion: "La prevención de la violencia laboral, y",
          status: "CUMPLE"
        },{
          descripcion: "Difunde en el centro de trabajo la política de prevención de riesgos psicosociales.",
          status: "CUMPLE"
        },{
          descripcion: "",
          status: ""
        }
      ]
    },{
      id:"116",
      tittle: "Lista verificación: 5.2; 7.1 a); 7.2; 7.4; 7.5; 7.6, 7.7; 7.8 y 7.9",
      info: "Los aspectos a verificar durante la evaluación de la conformidad de la presente Norma se realizarán, según aplique, mediante la revisión documental, registros o entrevistas, de conformidad con lo siguiente",
      steps: [
        {
          descripcion: "Realiza la identificación y análisis de los factores de riesgo psicosocial;",
          status: "CUMPLE",
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial comprende a todos los trabajadores del centro de trabajo;",
          status: "CUMPLE",
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial contempla, al menos, los factores siguientes:"+
          "Las condiciones en el ambiente de trabajo;"+
          "Las cargas de trabajo;"+
          "La falta de control sobre el trabajo;"+
          "Las jornadas de trabajo y rotación de turnos;"+
          "Interferencia en la relación trabajo-familia;"+
          "Liderazgo y relaciones negativas en el trabajo, y"+
          "La violencia laboral;",
          status: "NO CUMPLE",
        },{
          descripcion: "El método que se utiliza para realizar la identificación y análisis de los factores de riesgo psicosocial contiene:"+
          "Los cuestionarios que comprenden los factores enlistados en la viñeta anterior, conforme a dispuesto por el numeral 7.2 de la presente Norma;"+
          "La forma como se realiza la aplicación de los cuestionarios;"+
          "La manera de evaluar los cuestionarios, y"+
          "Los niveles y la forma de determinar el riesgo conforme a los resultados de los cuestionarios aplicados, y",
          status: "CUMPLE",
        },{
          descripcion: "Los cuestionarios que utiliza el centro de trabajo para la identificación y análisis de los factores de riesgo psicosocial están validados conforme a lo siguiente:"+
          "La validación fue realizada en trabajadores cuyos centros de trabajo se ubican en el territorio nacional;"+
          "El número de individuos que se utilizó para realizar la validación sea mayor o igual a 10 veces por cada reactivo contemplado inicialmente;"+
          "Tiene medidas de consistencia interna que presenta:"+
          "Coeficientes de confiabilidad (alfa de Cronbach) superiores a 0.7; y"+
          "Coeficientes de correlación (Pearson o Spearman), con r mayor a 0.5, y un nivel de significancia mayor o igual a 0.05;",
          status: "NO APLICA",
        },{
          descripcion: "Tiene validez de constructo mediante análisis factorial confirmatorio cumpliendo con medidas e índices de ajuste siguientes:"+
          "De ajuste absoluto con los índices:"+
          "Índice de Bondad de Ajuste, GFI (Goodness of Fit Index), mayor a 0.90;"+
          "Residuo cuadrático medio, RMSR (Root Mean Square Residual), cercana a 0 y máximo 0.08, y"+
          "Error de aproximación cuadrático medio, RMSEA (Root Mean Square Error of Approximation), menor a 0.08;"+
          "De ajuste incremental o relativo con el índice de ajuste normado, NFI (Normed Fit Index), mayor a 0.90, y"+
          "De parsimonia con el índice Ji cuadrada normada: X2/gl menor o igual a 5, y",
          status: "CUMPLE",
        },{
          descripcion: "Se aplican en población trabajadora de características semejantes a la población trabajadora en que se validó;",
          status: "CUMPLE",
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial está integrada al diagnóstico de seguridad y salud en el trabajo a que se refiere la NOM-030-STPS-2009, vigente o las que la sustituyan;",
          status: "CUMPLE",

        },{
          descripcion: "El resultado de la identificación y análisis de los factores de riesgo psicosocial consta en un informe que contiene lo siguiente:"+
          ".-Datos del centro de trabajo verificado:"+
          "Nombre, denominación o razón social;"+
          "Domicilio;"+
          "Actividad principal;"+
         ".-Objetivo;"+
          "Principales actividades realizadas en el centro de trabajo;"+
          "Método utilizado conforme al numeral 7.4, de la presente Norma;"+
          "Resultados obtenidos de acuerdo con el numeral 7.4, inciso d) de esta Norma,"+
          "Conclusiones;"+
         "Recomendaciones y acciones de intervención, en su caso, y"+
          "Datos del responsable de la evaluación;"+
          "Nombre completo, y"+
          "Número cédula profesional, en su caso",
          status: "CUMPLE",
        },{
          descripcion: "El resultado de la identificación y análisis de los factores de riesgo psicosocial está disponible para consulta de los trabajadores, y",
          status: "CUMPLE",
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial se realiza, al menos, cada dos años.",
          status: "NO APLICA",

        }
      ]
    }
  ]

  steps = [
    {
      id: "1161",
      descripcion: "La promoción de un entorno organizacional favorable;",
      status: "",
    },{
      id: "1161",
      descripcion: "La prevención de los factores de riesgo psicosocial, y",
      status: "",
    },{
      id: "1161",
      descripcion: "La prevención de la violencia laboral, y",
      status: "",
    },{
      id: "1161",
      descripcion: "Difunde en el centro de trabajo la política de prevención de riesgos psicosociales.",
      status: "",
    },{
      id: "1162",
      descripcion : "Realiza la identificación y análisis de los factores de riesgo psicosocial;",
      status : ""
    }, {
      id: "1162",
      descripcion : "La identificación y análisis de los factores de riesgo psicosocial comprende a todos los trabajadores del centro de trabajo;",
      status : ""
    }, {
      id: "1162",
      descripcion : "La identificación y análisis de los factores de riesgo psicosocial contempla, al menos, los factores siguientes:"+
      "Las condiciones en el ambiente de trabajo;"+
      "Las cargas de trabajo;"+
      "La falta de control sobre el trabajo;-"+
      "Las jornadas de trabajo y rotación de turnos;"+
      "Interferencia en la relación trabajo-familia;"+
      "Liderazgo y relaciones negativas en el trabajo, y"+
      "La violencia laboral;",
      status : ""
    },{
      id: "1162",
      descripcion : "El método que se utiliza para realizar la identificación y análisis de los factores de riesgo psicosocial contiene:"+
      "Los cuestionarios que comprenden los factores enlistados en la viñeta anterior, conforme a dispuesto por el numeral 7.2 de la presente Norma;"+
      "La forma como se realiza la aplicación de los cuestionarios;"+
      "La manera de evaluar los cuestionarios, y"+
      "Los niveles y la forma de determinar el riesgo conforme a los resultados de los cuestionarios aplicados, y",
      status : ""
    },{
      id: "1162",
      descripcion : "Los cuestionarios que utiliza el centro de trabajo para la identificación y análisis de los factores de riesgo psicosocial están validados conforme a lo siguiente:"+
      "La validación fue realizada en trabajadores cuyos centros de trabajo se ubican en el territorio nacional;"+
      "El número de individuos que se utilizó para realizar la validación sea mayor o igual a 10 veces por cada reactivo contemplado inicialmente;"+
      "Tiene medidas de consistencia interna que presenta:"+
      "Coeficientes de confiabilidad (alfa de Cronbach) superiores a 0.7; y"+
      "Coeficientes de correlación (Pearson o Spearman), con r mayor a 0.5, y un nivel de significancia mayor o igual a 0.05;",
      status : ""
    },{
      id: "1162",
      descripcion : "Tiene validez de constructo mediante análisis factorial confirmatorio cumpliendo con medidas e índices de ajuste siguientes:"+
      "De ajuste absoluto con los índices:"+
      "Índice de Bondad de Ajuste, GFI (Goodness of Fit Index), mayor a 0.90;"+
      "Residuo cuadrático medio, RMSR (Root Mean Square Residual), cercana a 0 y máximo 0.08, y"+
      "Error de aproximación cuadrático medio, RMSEA (Root Mean Square Error of Approximation), menor a 0.08;"+
      "De ajuste incremental o relativo con el índice de ajuste normado, NFI (Normed Fit Index), mayor a 0.90, y"+
      "De parsimonia con el índice Ji cuadrada normada: X2/gl menor o igual a 5, y",
      status : ""
    },{
      id: "1162",
      descripcion : "Se aplican en población trabajadora de características semejantes a la población trabajadora en que se validó;",
      status : ""
    },{
      id: "1162",
      descripcion : "La identificación y análisis de los factores de riesgo psicosocial está integrada al diagnóstico de seguridad y salud en el trabajo a que se refiere la NOM-030-STPS-2009, vigente o las que la sustituyan;",
      status : ""
    },{
      id: "1162",
      descripcion : "El resultado de la identificación y análisis de los factores de riesgo psicosocial consta en un informe que contiene lo siguiente:"+
      "Datos del centro de trabajo verificado:"+
      "Nombre, denominación o razón social;"+
      "Domicilio;"+
      "Actividad principal;"+
      "Objetivo;"+
      "Principales actividades realizadas en el centro de trabajo;"+
      "Método utilizado conforme al numeral 7.4, de la presente Norma;"+
      "Resultados obtenidos de acuerdo con el numeral 7.4, inciso d) de esta Norma,"+
      "Conclusiones;"+
      "Recomendaciones y acciones de intervención, en su caso, y"+
      "Datos del responsable de la evaluación;"+
      "Nombre completo, y"+
      "Número cédula profesional, en su caso",
      status : ""
    },{
      id: "1162",
      descripcion : "El resultado de la identificación y análisis de los factores de riesgo psicosocial está disponible para consulta de los trabajadores, y",
      status : ""
    },{
      id: "1162",
      descripcion : "La identificación y análisis de los factores de riesgo psicosocial se realiza, al menos, cada dos años.",
      status: ""
    }
  ]


  constructor(private activated: ActivatedRoute,
    private idiomasService: IdiomasServiceN35) {
  }

  ngOnInit() {
    $(window).scrollTop();
    this.activated.data.subscribe  (params=>{this.dataId = params});
  }

}
